import { NotifySDK } from '@ome/sdk';
import { resolveEnvironmentVariables } from '@inn/utils';
import { useTokenStore } from '@/storage/tokens';

const { variable: VITE_API_BASE } = resolveEnvironmentVariables('API_BASE');

const notifySdk = new NotifySDK({
  apiBase: VITE_API_BASE,
  token: () => useTokenStore().sysAccessToken,
  freshToken: () => useTokenStore().flush(),
});

export function useNotifySdk() {
  return notifySdk;
}
